import { Component } from '@angular/core';

@Component({
    selector: 'gbc-modal-section-column',
    templateUrl: './modal-section-column.component.html',
    styleUrls: ['./modal-section-column.component.scss'],
    standalone: true
})
export class ModalSectionColumnComponent {
}
